// Hàm tạo đường dẫn (slug) từ tên sản phẩm
export const createSlug = (name) => {
  if (!name) return "";
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[đĐ]/g, "d")
    .replace(/([^0-9a-z-\s])/g, "")
    .replace(/(\s+)/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
};

// Hàm định dạng tiền tệ VNĐ
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(amount);
};

// Hàm làm sạch dữ liệu HTML (Clear &nbsp; và khoảng trắng thừa)
export const cleanHTML = (html) => {
  if (!html) return "";
  return html
    .replace(/&nbsp;/g, ' ') // Thay khoảng trắng cứng bằng khoảng trắng thường
    .replace(/\s+/g, ' ')    // Loại bỏ các khoảng trắng dư thừa nối tiếp
    .trim();
};